var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { H2 } from "@irati/ui/src/Typography";
import Count from "@irati/ui/src/Count";
import Flex from "@irati/ui/src/Flex";
var StyledH2 = styled(H2)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline-block;\n  word-break: break-all;\n  max-width: 250px;\n  ", "\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline-block;\n  word-break: break-all;\n  max-width: 250px;\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.desktop(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-width: 400px;\n  "], ["\n    max-width: 400px;\n  "])));
});
var HeaderTitle = /** @class */ (function (_super) {
    __extends(HeaderTitle, _super);
    function HeaderTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderTitle.prototype.render = function () {
        var _a = this.props, title = _a.title, count = _a.count;
        return (React.createElement(Flex, { alignItems: "baseline" },
            React.createElement(StyledH2, { marginBottom: 4 }, title),
            count && React.createElement(Count, null, count)));
    };
    return HeaderTitle;
}(PureComponent));
export default HeaderTitle;
var templateObject_1, templateObject_2;
